import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { focusContent } from '../../lib/pageFocus';
import LogoMark from '../Brand/LogoMark';
import PassMenu from './PassMenu';
import ThemeToggle from './ThemeToggle';
import styles from './SiteHeader.module.css';

export default function SiteHeader() {
  const { t } = useTranslation();
  return (
    <header className={styles.header}>
      {/* Not a plain #content link: that would overwrite a secret link's #key. */}
      <a
        href="#content"
        className={styles.skip}
        onClick={(e) => {
          e.preventDefault();
          focusContent();
        }}
      >
        {t('nav.skip')}
      </a>
      <div className={styles.inner}>
        <Link to="/" className={styles.brand}>
          <LogoMark />
          <span className={styles.wordmark}>{t('brand.name')}</span>
        </Link>
        <nav aria-label={t('nav.label')} className={styles.nav}>
          <NavLink to="/send">{t('nav.send')}</NavLink>
          <NavLink to="/how-it-works">{t('nav.howItWorks')}</NavLink>
          <NavLink to="/security">{t('nav.security')}</NavLink>
          <NavLink to="/abuse">{t('nav.abuse')}</NavLink>
        </nav>
        {/* Settings, not destinations, so they sit outside the nav. On phones they
            share the top row with the brand and the links get a row of their own. */}
        <div className={styles.tools}>
          <PassMenu />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
